import { Category } from "../../Domain/Model/Category";
import { CategoryRepository } from "../../Domain/Repository/CategoryRepository";
import CategoryDataSource from "../DataSource/CategoryDataSource";

export class CategoryRepositoryImpl implements CategoryRepository {
  dataSource: CategoryDataSource;

  constructor(_datasource: CategoryDataSource) {
    this.dataSource = _datasource;
  }
  getCategories(): Promise<Category[]> {
    return this.dataSource.getCategories();
  }
  
   createCategory(data: Category): Promise<Category[]> {
    return this.dataSource.createCategory(data);
  }
  updateCategory(data: Category): Promise<boolean> {
    return this.dataSource.updateCategory(data);
  }
  
  removeCategory(id: string): Promise<boolean> {
    return this.dataSource.removeCategory(id);
  }
    
}